/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Status_PlannedInputs */

const vi_irrigation_run_status_planned = /** @type {(inputs: Irrigation_Run_Status_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp chạy`)
};

/**

* @param {Irrigation_Run_Status_PlannedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_status_planned = /** @type {((inputs?: Irrigation_Run_Status_PlannedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Status_PlannedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_status_planned(inputs)
});